interface Props {
    children: React.ReactNode
    href?: string
    onClick?: () => void
}
export function ButtonMobile({ children, href, onClick }: Props) {
    const className = "flex items-center justify-center rounded-xl border border-secondary/30 text-[0.8125rem] text-primary dark:text-gray-900 font-roboto font-bold py-3.5 bg-secondary hover:bg-secondary-dark no-underline text-center transition-all duration-200 active:scale-95 shadow-lg border-none cursor-pointer";

    if (onClick) {
        return (
            <button onClick={onClick} className={className}>
                {children}
            </button>
        )
    }

    return (
        <a
            href={href}
            target="_blank"
            rel="noreferrer"
            className={className}
        >{children}</a>
    )
}